import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { FileUploader } from "ng2-file-upload";
import { BrandingModel, BrandingColorList } from "./../models/branding.model";
import { OnInit, OnDestroy, Component, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Location } from "@angular/common";
import {
  WeGoConfig,
  IKeyValueInterface,
  ApplicationRouteURL,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { BrandingService } from "../models/branding.service";
import { InstanceService } from "../../instance/models/instance.service";
import { InstanceModel } from "../../instance/models/instance.model";
import { CompanyModel } from "../../company/models/company.model";
import { CompanyService } from "../../company/models/company.service";
import { DropdownModel } from "../../report/models/report-filter.model";

@Component({
  selector: "wego-branding",
  template: require('../views/branding.component.html'),
  styles: [
    `
      .form-horizontal .control-label{
        text-align: left;
      }
    `
  ],
  providers: [BrandingService, InstanceService, CompanyService]
})
export class BrandingComponent implements OnInit, OnDestroy {
  model: BrandingModel;
  errorModel: IKeyValueInterface[];

  instanceHashId: string = "";
  companyHashId: string = "";
  instanceList: DropdownModel[];
  companyList: DropdownModel[];

  isLoading: boolean;
  popupMsg: string;
  urlDefaultPage: string;
  pageName: string;
  roleLevel = RoleLevel;

  @ViewChild("notificationFile") public notificationFile: any;
  @ViewChild("expandedWebMenuFile") public expandedWebMenuFile: any;
  @ViewChild("collapsedWebMenuFile") public collapsedWebMenuFile: any;
  @ViewChild("mobileAppFile") public mobileAppFile: any;
  @ViewChild("splashScreenFile") public splashScreenFile: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private authService: AuthService,
    private locationService: Location,
    private translateService: TranslateService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private brandingService: BrandingService
  ) { }

  ngOnInit(): void {
    this.pageName = "Branding";
    // this.model = new BrandingModel();
    this.popupMsg = this.translateService.instant("LblBrandingSavedSuccess");
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.InitFilter();
  }

  public InitFilter() {
    //if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
    this.GetInstanceDropDownList(PermissionType.EDIT);
    this.instanceHashId = "";
    // }
  }

  public OnSubmit() {
    console.log(this.notificationFile);
    let formData: FormData = new FormData();

    if (
      this.notificationFile &&
      this.notificationFile.nativeElement &&
      this.notificationFile.nativeElement.files &&
      this.notificationFile.nativeElement.files.length > 0
    ) {
      formData.append(
        "notificationFile",
        this.notificationFile.nativeElement.files[0],
        this.notificationFile.nativeElement.files[0].name
      );
    }

    if (
      this.expandedWebMenuFile &&
      this.expandedWebMenuFile.nativeElement &&
      this.expandedWebMenuFile.nativeElement.files &&
      this.expandedWebMenuFile.nativeElement.files.length > 0
    ) {
      formData.append(
        "expandedWebMenuFile",
        this.expandedWebMenuFile.nativeElement.files[0],
        this.expandedWebMenuFile.nativeElement.files[0].name
      );
    }

    if (
      this.collapsedWebMenuFile &&
      this.collapsedWebMenuFile.nativeElement &&
      this.collapsedWebMenuFile.nativeElement.files &&
      this.collapsedWebMenuFile.nativeElement.files.length > 0
    ) {
      formData.append(
        "collapsedWebMenuFile",
        this.collapsedWebMenuFile.nativeElement.files[0],
        this.collapsedWebMenuFile.nativeElement.files[0].name
      );
    }

    if (
      this.mobileAppFile &&
      this.mobileAppFile.nativeElement &&
      this.mobileAppFile.nativeElement.files &&
      this.mobileAppFile.nativeElement.files.length > 0
    ) {
      formData.append(
        "mobileAppFile",
        this.mobileAppFile.nativeElement.files[0],
        this.mobileAppFile.nativeElement.files[0].name
      );
    }

    if (
      this.splashScreenFile &&
      this.splashScreenFile.nativeElement &&
      this.splashScreenFile.nativeElement.files &&
      this.splashScreenFile.nativeElement.files.length > 0
    ) {
      formData.append(
        "splashScreenFile",
        this.splashScreenFile.nativeElement.files[0],
        this.splashScreenFile.nativeElement.files[0].name
      );
    }

    if (this.model) {
      this.model.instanceHashId = this.instanceHashId;
      this.model.companyHashId = this.companyHashId;
      formData.append("brandingFormData", JSON.stringify(this.model));
    } else {
      formData.append("brandingFormData", JSON.stringify(new BrandingModel()));
    }
    this.UploadBranding(formData);
  }

  public GetBranding() {
    this.isLoading = true;
    this.brandingService
      .GetBranding(this.instanceHashId, this.companyHashId)
      .subscribe(
      res => {
        console.log(res);
        this.model = res.data;
        this.isLoading = false;
      },
      error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  public UploadBranding(formData: FormData) {
    this.brandingService.UploadBranding(formData).subscribe(
      res => {
        console.log(res);
        if (res.data) {
          this.ShowSuccessPopup();
          this.errorModel = [];
          this.ClearFileInput();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  // Helper Method
  public OnBackClick() {
    this.locationService.back();
  }

  public GetImageURL(imagePath: string) {
    if (imagePath) return WeGoConfig.API_SERVER_URL + imagePath;
    else return "";
  }

  public GetBrandingColorList(
    brandingColorList: BrandingColorList[],
    type: string
  ) {
    if (brandingColorList) {
      return brandingColorList.filter(x => x.type == type);
    }
    return new Array();
  }

  public ClearFileInput() {
    if (this.notificationFile && this.notificationFile.nativeElement) {
      this.notificationFile.nativeElement.value = "";
    }
    if (this.expandedWebMenuFile && this.expandedWebMenuFile.nativeElement) {
      this.expandedWebMenuFile.nativeElement.value = "";
    }
    if (this.collapsedWebMenuFile && this.collapsedWebMenuFile.nativeElement) {
      this.collapsedWebMenuFile.nativeElement.value = "";
    }
    if (this.mobileAppFile && this.mobileAppFile.nativeElement) {
      this.mobileAppFile.nativeElement.value = "";
    }
    if (this.splashScreenFile && this.splashScreenFile.nativeElement) {
      this.splashScreenFile.nativeElement.value = "";
    }
  }

  public GetDefaultCompanySelection() {
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
      return "-";
    }
    else
    {
      return (
        this.translateService.instant("LblSelect") +
        " " +
        this.translateService.instant("LblCompany")
      );
    }
  }
  // End Helper Method

  ngOnDestroy(): void { }

  // Filter List
  private GetInstanceDropDownList(permissionType: string) {
    this.instanceService
      .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
      .subscribe(
      res => {
        this.instanceList = res.data;

        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.instanceHashId && this.instanceList.length == 1) {
            this.instanceHashId = this.instanceList[0].keyHash;
          }
          this.OnInstanceChange();
        }
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
      );
  }

  private GetCompanyDropDownList(instanceHashId: string) {
    this.companyService
      .GetCompanyListDropdownForAddUpdatePage(
      this.pageName,
      PermissionType.EDIT,
      instanceHashId
      )
      .subscribe(
      res => {
        this.companyList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
      );
  }
  // End Filter List

  // Event
  public OnInstanceChange() {
    if (this.instanceHashId) {
      this.GetCompanyDropDownList(this.instanceHashId);
    } else {
      this.companyList = [];
    }
    this.companyHashId = "";
    this.OnCompanyChange();
  }

  public OnCompanyChange() {
    if ((this.instanceHashId && this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) || this.companyHashId) {
      this.GetBranding();
    } else {
      this.model = null;
    }
    this.errorModel = [];
    this.ClearFileInput();
  }
  // End Event

  // Success Popup Event
  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.GetBranding();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.GetBranding();
  }
  // End Success Popup Event
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/branding/components/branding.component.ts